import dynamic from 'next/dynamic'
import { useIntersectionObserver } from 'usehooks-ts'

import { SanityMediaTextBlock } from '@data/sanity/queries/types/blocks'
import { SanityVideo } from '@data/sanity/queries/types/video'

import Photo from '@components/photo'
import ComplexPortableText from '@components/portable-text/complex'
const MuxVideo = dynamic(() => import('@components/video/mux-video'))

type MediaTextProps = Pick<
  SanityMediaTextBlock,
  'mediaType' | 'image' | 'video' | 'content'
>

interface MediaTextVideoProps {
  video: SanityVideo
}

const MediaTextVideo = ({ video }: MediaTextVideoProps) => {
  const { ref: videoRef, isIntersecting: isVideoIntersecting } =
    useIntersectionObserver({
      freezeOnceVisible: true,
      threshold: 0.1,
    })

  if (!video.muxVideo) {
    return null
  }

  return (
    <div ref={videoRef}>
      {isVideoIntersecting && (
        <MuxVideo
          video={video.muxVideo}
          showControls={video.settings?.controls}
          autoplay={video.settings?.autoplay}
          autoplayOnHover={video.settings?.autoplayOnHover}
          openModalOnClick={video.settings?.openModalOnClick}
          loop={video.settings?.loop}
          muted={video.settings?.muted}
          borderRadius={video.borderRadius}
          aspectRatio={video.aspectRatio}
        />
      )}
    </div>
  )
}

const MediaText = ({ mediaType, image, video, content }: MediaTextProps) => {
  return (
    <>
      {mediaType === 'video' && !!video && <MediaTextVideo video={video} />}
      {mediaType === 'image' && !!image && <Photo image={image} />}

      <div className="p-10">
        <ComplexPortableText content={content} className="rc" />
      </div>
    </>
  )
}

export default MediaText
